import {
  UseReflectionHomePageDataArgs,
  UseReflectionHomePageDataReturn,
} from "./types";
import {
  filterEntriesForReflectionPersonalSummary,
  getReflectionEntryData,
} from "../useReflectionPersonalSummaryData/utils";
import {
  filterEntriesByModule,
  enrichDynamicTestSetsWithCategory,
  filterDynamicTestSetsByEntriesSession,
} from "../../utils";
import { Module } from "../../../../../constants";
import {
  countByCategory,
  calculateTotalsByType,
  convertCountsToPercentages,
} from "./utils";

export function useReflectionHomePageData({
  rawData,
  selectedFilters,
}: UseReflectionHomePageDataArgs): UseReflectionHomePageDataReturn {
  const reflectionEntries = filterEntriesByModule(
    rawData?.allEntries ?? [],
    Module.Reflection,
    selectedFilters
  );

  const personalityPoints = filterEntriesForReflectionPersonalSummary(
    reflectionEntries
  ).map(entry => getReflectionEntryData(entry).points[0]);

  const dynamicTestSets = filterDynamicTestSetsByEntriesSession(
    rawData?.dynamicTestSets ?? [],
    reflectionEntries,
    Module.Reflection
  );
  const testSets = rawData?.testSets ?? [];

  const dynamicTestSetsWithCategory = enrichDynamicTestSetsWithCategory(
    dynamicTestSets,
    testSets
  );

  const countsByCategory = countByCategory(dynamicTestSetsWithCategory);
  const totalsByType = calculateTotalsByType(countsByCategory);
  const cubeValuesByCategory = convertCountsToPercentages(
    countsByCategory,
    totalsByType
  );

  return {
    cubeValuesByCategory,
    personalityPoints,
  };
}
